import React from 'react';
import PropTypes from 'prop-types';
import { recordIntent, divIdNumToRPSMap } from '../../../lib/appcenterIntent';
import { CHECKOUT } from '../../../lib/constants';
import OptimizedImage from './OptimizedImage';
import DetailsText from './DetailsText';
import {
  fireDetailsPageComponentFailureFpti,
  parseData,
  preventTabNabbing
} from '../../../lib/helpers';

class DetailsPhotoSection extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  handleClick = (url, fptiLink) => {
    const {
      componentContent: { toolKey = '' } = {},
      handleClickFPTI,
      app
    } = this.props;
    const { context: { location: { domain } = {} } = {} } = app;
    const number = this.ref.current.id.split('-').pop();
    handleClickFPTI(fptiLink);
    if (toolKey === CHECKOUT) {
      /* brittle, if the order of the rows change, the wrong intents are fired */
      /* ideal solution: move RPS product key to PS */
      const product = divIdNumToRPSMap[number];
      this.recordRPSIntent(product, url);
    } else {
      window.open(url, '_blank', `${preventTabNabbing(url, domain)}`);
    }
  };

  recordRPSIntent = (product, url) => {
    const { app } = this.props;
    recordIntent({
      csrf: app.csrf,
      productArr: [product]
    }).finally(() => {
      window.location.href = url;
    });
  };

  render() {
    const {
      handleClickFPTI,
      componentContent,
      fptiImpression,
      toolName,
      app
    } = this.props;
    const {
      direction,
      image = '',
      cta = '',
      desc = '',
      subtitle,
      ctaIcons,
      title,
      style
    } = componentContent;

    const parsedCta = parseData(cta);
    const parsedCtaIcons = parseData(ctaIcons);
    const parsedDesc = parseData(desc);

    if (!title || !subtitle || !direction || !image) {
      fireDetailsPageComponentFailureFpti({
        data: { title, cta, image, subtitle, desc },
        componentName: 'DetailsPhotoSection',
        fptiImpression
      });
      return null;
    }

    let styleObject = {};

    if (style) {
      styleObject = parseData(style);
    }
    return (
      <section id="details-options" ref={this.ref} style={styleObject}>
        <div
          className={`details-option-list-item${
            direction === 'rtl' ? '-rtl' : ''
          }`}
        >
          <DetailsText
            app={app}
            title={title}
            subtitle={subtitle}
            direction={direction}
            extraInfo={parsedDesc}
            ctaText={parsedCta[0]?.text}
            ctaUrl={parsedCta[0]?.url}
            isLink={parsedCta[0]?.isLink === 'true'}
            fptiLinkName={parsedCta[0]?.fptiLinkName}
            imageButtonValues={parsedCtaIcons}
            handleClickFPTI={handleClickFPTI}
            handleClick={this.handleClick}
            toolName={toolName}
          />
          <div className="details-option-image-container">
            <OptimizedImage
              imageUrl={image}
              className={`details-option-image-tag`}
            />
          </div>
        </div>
      </section>
    );
  }
}

DetailsPhotoSection.propTypes = {
  componentContent: PropTypes.object,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  direction: PropTypes.string,
  imageUrl: PropTypes.string,
  fptiImpression: PropTypes.func,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  extraItem: PropTypes.object,
  handleClickFPTI: PropTypes.func,
  app: PropTypes.object,
  toolName: PropTypes.string
};

export default DetailsPhotoSection;
